import classNames from 'classnames';

export const Merchant = ({
  logo,
  selected,
  onSelect
}: {
  logo: React.ReactNode;
  selected: boolean;
  onSelect: () => void;
}) => (
  <div
    onClick={onSelect}
    className={classNames('rounded-19 p-[0.063rem]', {
      'from-green-450 to-blue-450 bg-gradient-to-tl': selected,
      ' bg-gray-200': !selected
    })}
  >
    <div className="rounded-18 bg-white">
      <div
        className={classNames('z-10 flex h-14 cursor-pointer items-center justify-center rounded-18 font-bold', {
          'bg-white/15': selected,
          'border border-white': !selected
        })}
      >
        {logo}
      </div>
    </div>
  </div>
);
